module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_PIRITE_VERTICALE.d6c8f09f.png";